import { render, staticRenderFns } from "./InstitutionSettings.vue?vue&type=template&id=269cef4c"
import script from "./InstitutionSettings.vue?vue&type=script&lang=js"
export * from "./InstitutionSettings.vue?vue&type=script&lang=js"
import style0 from "./InstitutionSettings.vue?vue&type=style&index=0&id=269cef4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports